import { Select, MenuItem } from "@mui/material";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import styled from "styled-components";

export const TimePicker = ({ value, onChange, disabled, showHiddenInputs = false }) => {
  const [hour, setHour] = useState("00");
  const [minute, setMinute] = useState("00");

  // Parse initial value (e.g., "14:30" or "2:30 PM")
  useEffect(() => {
    if (value) {
      const timeParts = value.split(":");
      if (timeParts.length >= 2) {
        setHour(timeParts[0].padStart(2, "0"));
        setMinute(timeParts[1].substring(0, 2).padStart(2, "0"));
      }
    }
  }, [value]);

  // Generate hour options (00-23)
  const hourOptions = Array.from({ length: 24 }, (_, i) => {
    const hourValue = i.toString().padStart(2, "0");
    return (
      <MenuItem key={hourValue} value={hourValue}>
        {hourValue}
      </MenuItem>
    );
  });

  // Generate minute options (every 5 minutes)
  const minuteOptions = Array.from({ length: 12 }, (_, i) => {
    const minuteValue = (i * 5).toString().padStart(2, "0");
    return (
      <MenuItem key={minuteValue} value={minuteValue}>
        {minuteValue}
      </MenuItem>
    );
  });

  const handleHourChange = (event) => {
    const newHour = event.target.value;
    setHour(newHour);
    if (onChange) {
      onChange(`${newHour}:${minute}`);
    }
  };

  const handleMinuteChange = (event) => {
    const newMinute = event.target.value;
    setMinute(newMinute);
    if (onChange) {
      onChange(`${hour}:${newMinute}`);
    }
  };

  return (
    <StyledTimePicker>
      <Select
        onChange={handleHourChange}
        value={hour}
        disabled={disabled}
        size="small"
        label={"hour"}
        displayEmpty
      >
        {hourOptions}
      </Select>
      <span>:</span>
      <Select
        onChange={handleMinuteChange}
        value={minute}
        disabled={disabled}
        size="small"
        displayEmpty
      >
        {minuteOptions}
      </Select>

      {showHiddenInputs && (
        <>
          <input type="hidden" name="hour" value={hour} />
          <input type="hidden" name="minute" value={minute} />
          <input type="hidden" name="time" value={`${hour}:${minute}`} />
        </>
      )}
    </StyledTimePicker>
  );
};

TimePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.any,
  disabled: PropTypes.any,
  showHiddenInputs: PropTypes.any,
  label: PropTypes.string
};

const StyledTimePicker = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  .MuiSelect-select {
    padding: 8px 12px;
    min-width: 60px;
  }

  span {
    font-weight: bold;
    font-size: 16px;
  }
`;
